import { SA_APP_HOSTNAME, SA_ENV, getCookieDomain, getSecureCookieConfig } from '../config/app.config';
//---------------------------------------------------------

// Secure cookie utility functions for cross-domain authentication
export const fSetSecureCookie = (name, value, options = {}) => {
  const cookieConfig = getSecureCookieConfig(SA_ENV)
  const domain = getCookieDomain(SA_ENV)

  const defaultOptions = {
    domain: domain,
    secure: cookieConfig.secure, // Secure=true for remote, false for local
    sameSite: cookieConfig.sameSite, // SameSite=None for cross-domain, Lax for local
    httpOnly: false, // HttpOnly=false to allow frontend access
    expires: 7, // 7 days default
    ...options
  }

  // Build cookie string manually for better control
  const expires = new Date()
  expires.setDate(expires.getDate() + defaultOptions.expires)

  let cookieString = `${name}=${encodeURIComponent(value)}`
  cookieString += `; expires=${expires.toUTCString()}`
  cookieString += `; domain=${defaultOptions.domain}`
  cookieString += `; path=/`
  cookieString += `; SameSite=${defaultOptions.sameSite}`

  if (defaultOptions.secure) {
    cookieString += `; Secure`
  }

  document.cookie = cookieString
}

export const fGetSecureCookie = (name) => {
  const match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

export const fRemoveSecureCookie = (name) => {
  const domain = getCookieDomain(SA_ENV)

  // Remove from current domain
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`

  // Also try to remove from parent domain to ensure cleanup
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${domain}; path=/`
}

export const parseHttpHeaders = (httpHeaders) => {
	//parseHttpHeaders(new XmlHttpRequest.getAllResponseHeaders());
    return httpHeaders.split("\n")
     .map(x=>x.split(/: */,2))
     .filter(x=>x[0])
     .reduce((ac, x)=>{ac[x[0]] = x[1];return ac;}, {});
}

export const parseQStr = (str) => {
	let res={}, theKV = str.substring(0, 1) === '?' ?// str.startsWith('?')
	 	str.slice(1).split('&') : str.split('&');
	theKV.forEach(sKV => {
		let tKV = sKV.split('=');
		res[tKV[0]] = decodeURIComponent(tKV[1] || '');
	});
	return res;
}

export const j2q = (jKV) => {//jKV[k]!==null
	return Object.keys(jKV).map(k => k+'='+jKV[k]).join('&');
}

export const fWriteCook = (cName, cVal, maxAge=1200)=> {
	//const fTest=1;
	//maxAge = maxAge ?? fTest ? 1200 : 120;
	const cDt = new Date();
	cDt.setSeconds(cDt.getSeconds() + maxAge);
	let cStr = cName + '=' + encodeURIComponent(cVal);
	cStr += ';expires=' + cDt + ';max-age='+(maxAge*1)+';samesite:strict';
	cStr += ';domain=' + SA_APP_HOSTNAME;
	cStr += ';path=/;Secure';//HttpOnly
	document.cookie = cStr;
	return true;
}

export const fGetCookie = (cName) => {
    let match = document.cookie.match(RegExp('(?:^|;\\s*)' + cName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

export const fDelCookie = (cName) => {
	document.cookie = cName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=' + SA_APP_HOSTNAME+';path=/';
}

export const getFileExtension = fName => {
	fName = fName && fName.split('?')[0];
	return fName.split('.').pop();
}

export const isValidUrl = urlString=> {
	var urlPattern = new RegExp('^(https?:\\/\\/)?' +
	'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
	'((\\d{1,3}\\.){3}\\d{1,3}))' +
	'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
	'(\\?[;&a-z\\d%_.~+=-]*)?' +
	'(\\#[-a-z\\d_]*)?$','i');
	return urlPattern.test(urlString);
}
